import {DateField, Panes, prefixWithSeparator, TextField} from '@management-ui/core';
import {Box, FormControl, InputLabel, MenuItem, Select} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {useFormContext} from 'react-hook-form';
import YesNoField from '../../../../components/YesNoField';
import {joinAddress, saveDate} from '../../../../utilities';

const Collection = ({order = {}, prefix = ''}) => {
  const [location, setLocation] = useState('');
  const {setValue} = useFormContext();

  useEffect(() => {
    if (order?.supplier) {
      const index = order.supplier.locations.findIndex(({id}) => `${id}` === location);
      if (index >= 0) {
        setValue(`${prefixWithSeparator(prefix)}collection_address`, joinAddress(order.supplier.locations[index], [order.supplier.name]));
      }
    }
  }, [order, prefix, location, setValue]);

  return (
    <Panes
      entity={order}
      prefix={prefix}
      panes={[
        {
          title: 'Collection Address',
          fields: [
            <Box marginY={2}>
              <FormControl fullWidth disabled={(order?.supplier?.locations ?? []).length < 1}>
                <InputLabel id="locationLabel">Location</InputLabel>
                <Select
                  labelId="locationLabel"
                  value={location}
                  label="Location"
                  onChange={(e) => setLocation(e.target.value)}
                >
                  {(order?.supplier?.locations ?? []).map((l, i) => (
                    <MenuItem key={i} value={`${l.id}`}>{l.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>,
            <TextField
              name="collection_address"
              prefix={prefix}
              label="Collection Address"
              fieldProps={{multiline: true, rows: 4}}
            />,
          ]
        },
        {
          title: 'Collection Date',
          fields: [
            <DateField
              name="collection_date"
              prefix={prefix}
              label="Collection Date"
            />,
            <YesNoField
              name="collection_date_confirmed"
              prefix={prefix}
              label="Collection Date Confirmed"
            />
          ]
        }
      ]}
      title=""
    />
  );
};

Collection.onSave = ({collection_address, collection_date, collection_date_confirmed}) => ({
  collection_address,
  collection_date: saveDate(collection_date),
  collection_date_confirmed
});

export default Collection;
